import { BoolEdit } from '@powerportalspro/react-fluent';

export function BoolEditMainSample() {
  return <BoolEdit columnName="ppp_credithold" />;
}
